import { acpCardUseSettingsStates } from './states';

export default (appModule) => {
  appModule.config(acpCardUseSettingsStates);
};
